var _g, _path, _g2, _path2, _g3, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarifficationSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 224,
    viewBox: "0 0 230 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_281_1423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.607 4.983a2.83 2.83 0 00-2.78 2.869v148.103a2.829 2.829 0 002.78 2.869h108.106a2.83 2.83 0 002.781-2.869V7.852a2.828 2.828 0 00-2.781-2.87H7.607z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.905 82.395H50.1c-.276 0-.549-.063-.804-.189a2.116 2.116 0 01-.68-.542 2.574 2.574 0 01-.456-.811 2.92 2.92 0 01-.16-.957c0-.329.054-.654.16-.958.105-.303.26-.58.455-.811.195-.232.427-.416.681-.542.255-.125.528-.19.804-.19h49.805c.556.001 1.089.265 1.482.734.392.468.613 1.104.613 1.766 0 .663-.221 1.299-.613 1.767-.393.47-.926.733-1.482.733zm0-45H50.1c-.276 0-.549-.064-.804-.189a2.116 2.116 0 01-.68-.542 2.574 2.574 0 01-.456-.811 2.92 2.92 0 01-.16-.958c0-.328.054-.653.16-.957.105-.303.26-.58.455-.811.195-.232.427-.416.681-.542.255-.126.528-.19.804-.19h49.805c.556.001 1.089.265 1.482.734.392.468.613 1.104.613 1.767 0 .662-.221 1.297-.613 1.766-.393.47-.926.733-1.482.733zm8.986 54h-58.78a1.82 1.82 0 01-.807-.189 2.124 2.124 0 01-.685-.542 2.572 2.572 0 01-.458-.811 2.906 2.906 0 01-.161-.957c0-.329.055-.654.16-.958.107-.303.263-.58.459-.811.196-.232.428-.416.685-.542.256-.125.53-.19.807-.19h58.78c.559 0 1.096.264 1.491.733.396.469.618 1.105.618 1.767 0 .663-.222 1.3-.618 1.768-.395.47-.932.733-1.491.733zm0-45h-58.78c-.277 0-.551-.064-.807-.189a2.124 2.124 0 01-.685-.542 2.572 2.572 0 01-.458-.811 2.906 2.906 0 01-.161-.958c0-.328.055-.653.16-.957.107-.303.263-.58.459-.811.196-.232.428-.416.685-.542.256-.126.53-.19.807-.19h58.78c.559 0 1.096.264 1.491.733.396.469.618 1.105.618 1.767 0 .663-.222 1.3-.618 1.768-.395.47-.932.733-1.491.733zm-8.988 77.001H50.1a1.57 1.57 0 01-.804-.228 2.218 2.218 0 01-.68-.65 3.299 3.299 0 01-.456-.974 4.14 4.14 0 01-.16-1.149c0-.394.054-.784.16-1.148.105-.365.26-.695.455-.974s.427-.5.681-.65c.255-.151.528-.228.804-.227h49.803c.556 0 1.089.316 1.483.878.393.563.614 1.326.614 2.121 0 .796-.221 1.559-.614 2.122-.394.562-.927.879-1.483.879zm8.986 9H50.111c-.277 0-.551-.065-.807-.19a2.122 2.122 0 01-.686-.542 2.573 2.573 0 01-.457-.811 2.91 2.91 0 010-1.915c.106-.303.261-.579.457-.811.197-.232.43-.417.685-.542.257-.125.531-.19.808-.189h58.778a1.82 1.82 0 01.807.189c.257.125.489.31.685.542.197.232.352.508.458.811a2.915 2.915 0 010 1.915 2.554 2.554 0 01-.458.811 2.111 2.111 0 01-.685.542c-.256.125-.53.19-.807.19zM35.94 95.745H13.293A1.293 1.293 0 0112 94.452v-20.16A1.294 1.294 0 0113.292 73h22.649a1.294 1.294 0 011.292 1.292v20.16a1.294 1.294 0 01-1.292 1.293zm0-45H13.293A1.293 1.293 0 0112 49.452v-20.16A1.294 1.294 0 0113.292 28h22.649a1.294 1.294 0 011.292 1.292v20.16a1.294 1.294 0 01-1.292 1.293zm0 85.763H13.293A1.293 1.293 0 0112 135.216v-20.161a1.294 1.294 0 011.292-1.292h22.649a1.298 1.298 0 011.292 1.292v20.161a1.294 1.294 0 01-1.292 1.292z",
    fill: "#E6E6E6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_281_1423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.937 40.173a2.829 2.829 0 00-2.78 2.869v148.103a2.829 2.829 0 002.78 2.869h108.107a2.83 2.83 0 002.78-2.869V43.042a2.828 2.828 0 00-2.78-2.87H47.937z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.905 123H91.1c-.276 0-.549-.064-.804-.19a2.108 2.108 0 01-.68-.541 2.569 2.569 0 01-.456-.812 2.914 2.914 0 01-.16-.957c0-.329.054-.654.16-.957.105-.304.26-.58.455-.812.195-.232.427-.416.681-.542.255-.125.528-.189.804-.189h49.805c.556.001 1.089.264 1.482.733.392.469.613 1.104.613 1.767 0 .663-.221 1.298-.613 1.767-.393.469-.926.732-1.482.733zm8.986 9h-58.78c-.277 0-.551-.064-.807-.19a2.116 2.116 0 01-.685-.541 2.567 2.567 0 01-.458-.812A2.9 2.9 0 0189 129.5a2.9 2.9 0 01.16-.957 2.59 2.59 0 01.459-.812c.196-.232.428-.416.685-.542.256-.125.53-.189.807-.189h58.78c.559 0 1.096.263 1.491.732.396.469.618 1.105.618 1.768s-.222 1.299-.618 1.768c-.395.469-.932.732-1.491.732zm-8.988 32H91.1c-.276 0-.549-.077-.804-.227a2.242 2.242 0 01-.68-.65 3.31 3.31 0 01-.456-.974A4.146 4.146 0 0189 161c0-.394.054-.785.16-1.149a3.31 3.31 0 01.455-.974 2.25 2.25 0 01.681-.65c.255-.15.528-.227.804-.227h49.803c.556 0 1.089.316 1.483.879.393.562.614 1.325.614 2.121s-.221 1.559-.614 2.121c-.394.563-.927.879-1.483.879zm8.986 9H91.111c-.277 0-.551-.064-.808-.19a2.118 2.118 0 01-.684-.541 2.567 2.567 0 01-.458-.812A2.9 2.9 0 0189 170.5a2.9 2.9 0 01.16-.957 2.57 2.57 0 01.459-.812c.196-.232.428-.416.684-.541.257-.126.531-.19.808-.19h58.778c.277 0 .551.064.807.19.257.125.489.309.685.541.197.232.352.508.458.812a2.904 2.904 0 010 1.914c-.106.304-.261.58-.458.812a2.108 2.108 0 01-.685.541c-.256.126-.53.19-.807.19zM76.94 136.349H54.293A1.292 1.292 0 0153 135.057v-20.16a1.296 1.296 0 011.292-1.293h22.649a1.298 1.298 0 011.292 1.293v20.16a1.292 1.292 0 01-1.292 1.292zm0 40.763H54.293A1.293 1.293 0 0153 175.82v-20.16a1.294 1.294 0 011.292-1.293h22.649a1.298 1.298 0 011.292 1.293v20.16a1.294 1.294 0 01-1.292 1.292z",
    fill: "#E6E6E6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_281_1423)",
    filter: "url(#filter2_d_281_1423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.62 79.491l-2.264-.143-2.068-5.581-7.286-.859-3.544 6.726.196 1.86-.492 1.718-23.335.286v-.858l-.03-2.324h1.273l-.947-.968-4.53-5.581s-7.778.286-7.876 0c-.098-.286.443-3.22.443-3.22l3.348-1.43 11.42-1.289c2.512-5.796 4.776-8.515 4.776-8.515h29.341l1.378 10.304v.024l.197 9.85z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.973 80.628a7.316 7.316 0 01-7 7.308 7.317 7.317 0 01-7.624-7.039v-.006a7.31 7.31 0 017.31-7.576 7.315 7.315 0 017.314 7.313z",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126.973 80.628a7.316 7.316 0 01-7 7.308 7.317 7.317 0 01-7.624-7.039v-.006a7.31 7.31 0 017.31-7.576 7.315 7.315 0 017.314 7.313z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.658 84.617a3.99 3.99 0 100-7.98 3.99 3.99 0 000 7.98z",
    fill: "#DCE0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.656 83.024a2.394 2.394 0 100-4.788 2.394 2.394 0 000 4.788zm-30.87-2.396a7.315 7.315 0 01-14.624.27v-.007a7.315 7.315 0 1114.624-.263z",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.786 80.628a7.315 7.315 0 01-14.624.27v-.007a7.315 7.315 0 1114.624-.263z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.47 84.617a3.99 3.99 0 100-7.98 3.99 3.99 0 000 7.98z",
    fill: "#DCE0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.474 83.024a2.394 2.394 0 100-4.788 2.394 2.394 0 000 4.788z",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.259 79.742s3.228-7.698 5.703-7.698h6.026s1.507 0 2.153 1.512l2.475 6.186h-1.937s-1.614-5.774-3.444-5.911c-1.829-.138-4.95 0-4.95 0s-1.076 0-1.722 1.65c-.645 1.649-2.828 5.242-2.828 5.242s-2.337.943-1.476-.981z",
    fill: "#FF7676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.891 78.408h-3.78l-.039 3.818 3.819-1.145v-2.673zm-53.069-3.623s-.184-1.233 1.292-2.056l9.697-.685s1.58.137 2.424 2.742l2.74 5.346v.822H88.92s-1.476-7.265-5.692-6.99l-4.617-.01s-.442-.086-1.91 1.272l-.878-.44zm19.971-15.471h30.549c0-.337-.115-.661-.321-.9a1.022 1.022 0 00-.774-.373h-28.36a.963.963 0 00-.418.097 1.1 1.1 0 00-.355.276 1.302 1.302 0 00-.238.413c-.055.155-.083.32-.083.487z",
    fill: "#FF7676"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.009 68.224H95.502c-.163 0-.324-.034-.468-.099a.935.935 0 01-.354-.27.691.691 0 01-.074-.773l2.296-4.278c.354-.66.707-1.524 1.438-1.918.731-.394 1.809-.3 2.681-.3h8.814c.162 0 .322.027.472.078.15.052.286.127.4.222.115.095.206.208.268.332a.873.873 0 01.094.39v5.738c0 .115-.028.23-.081.336a.876.876 0 01-.23.285 1.088 1.088 0 01-.344.19 1.246 1.246 0 01-.405.067z",
    fill: "#E93A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.615 69.221v.024l-13.646.251-.356-10.182h12.521l1.481 9.907z",
    fill: "#FF7676"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M124.669 60.588h-8.108c-.221 0-.401.27-.401.604v6.429c0 .334.18.604.401.604h8.108c.222 0 .401-.27.401-.604v-6.429c0-.334-.179-.604-.401-.604z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.963 70.769h-2.33c-.059 0-.108.129-.108.288v.697c0 .159.049.288.108.288h2.33c.06 0 .108-.13.108-.288v-.697c0-.159-.048-.288-.108-.288z",
    fill: "#FF7676"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.759 154.486l-39.833 39.513a2.648 2.648 0 01-3.745-.015l-18.954-19.107a2.648 2.648 0 01.015-3.745l1.881-1.865a2.648 2.648 0 013.745.015l15.223 15.346 36.072-35.783a2.648 2.648 0 013.745.015l1.866 1.881a2.648 2.648 0 01-.015 3.745z",
    fill: "#49BC74"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_281_1423",
    x: 2.826,
    y: 3.983,
    width: 117.668,
    height: 157.841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_281_1423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_281_1423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_281_1423",
    x: 43.156,
    y: 39.173,
    width: 117.668,
    height: 157.841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_281_1423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_281_1423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_281_1423",
    x: 73.156,
    y: 46,
    width: 56.734,
    height: 56.734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_281_1423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_281_1423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_281_1423"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(74.156 46)",
    d: "M0 0h54.734v54.734H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarifficationSuccess);
export default __webpack_public_path__ + "static/media/tarifficationSuccess.1215ddc8d4b18c8b02221dce20ac1e5d.svg";
export { ForwardRef as ReactComponent };